import { render, staticRenderFns } from "./pmmxIndex.vue?vue&type=template&id=0d53ee68&scoped=true"
import script from "./pmmxIndex.vue?vue&type=script&lang=js"
export * from "./pmmxIndex.vue?vue&type=script&lang=js"
import style0 from "./pmmxIndex.vue?vue&type=style&index=0&id=0d53ee68&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/.store/vue-loader@15.11.1/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0d53ee68",
  null
  
)

export default component.exports